import { FormData } from '../types';

export const validateForm = (formData: FormData): boolean => {
  return !!(
    formData.organizationName &&
    formData.contactName &&
    formData.jobTitle &&
    formData.phone &&
    formData.email &&
    formData.businessType &&
    formData.useMonths &&
    formData.paymentMethod &&
    formData.contactAvailableTime &&
    formData.personalInfoConsent
  );
};

export const getInitialFormData = (): FormData => ({
  organizationName: '',
  contactName: '',
  jobTitle: '',
  phone: '',
  email: '',
  businessType: '',
  contentPurpose: '',
  operationStartDate: '',
  operationEndDate: '',
  useMonths: 0,
  paymentMethod: '',
  contactAvailableTime: '',
  inquiryContent: '',
  personalInfoConsent: false
});
